import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type CareerIconProps = CommonSvgProps

const CareerIcon: React.FC<CareerIconProps> = React.forwardRef<SVGSVGElement, CareerIconProps>(
  (props, ref) => (
    <Svg viewBox="0 0 33 33" {...props} ref={ref} color="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.693 22.298c-1.33 1.475-1.943 3.156-2.028 3.97a.852.852 0 1 1-1.694-.178c.127-1.213.914-3.223 2.457-4.933 1.571-1.741 3.965-3.212 7.298-3.212 3.348 0 5.744 1.557 7.283 3.334a10.649 10.649 0 0 1 1.694 2.672c.361.827.57 1.628.57 2.228a.852.852 0 1 1-1.703 0c0-.27-.113-.825-.428-1.545a8.95 8.95 0 0 0-1.421-2.24c-1.282-1.48-3.235-2.746-5.995-2.746-2.775 0-4.73 1.207-6.033 2.65Z"
        fill="#51565C"
      />
      <path d="M17.448 10.846a5.11 5.11 0 1 1-10.222 0 5.11 5.11 0 0 1 10.222 0Z" fill="#7BB835" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.336 14.253a3.407 3.407 0 1 0 0-6.815 3.407 3.407 0 0 0 0 6.815Zm0 1.704a5.11 5.11 0 1 0 0-10.222 5.11 5.11 0 0 0 0 10.221ZM22.922 18.812a7.23 7.23 0 0 0-2.518.471c-.826.315-1.662.816-2.218 1.557a.852.852 0 1 0 1.363 1.023c.295-.394.81-.74 1.46-.987a5.528 5.528 0 0 1 1.908-.36h.003c2.166 0 3.696.99 4.704 2.154a7.047 7.047 0 0 1 1.118 1.762c.25.57.331.994.331 1.179a.852.852 0 0 0 1.704 0c0-.515-.178-1.185-.474-1.861a8.744 8.744 0 0 0-1.391-2.195c-1.265-1.46-3.237-2.743-5.99-2.743Z"
        fill="#51565C"
      />
      <path
        d="M26.723 13.259a4.117 4.117 0 1 1-8.235 0 4.117 4.117 0 0 1 8.235 0Z"
        fill="#53A2D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.605 15.673a2.414 2.414 0 1 0 0-4.828 2.414 2.414 0 0 0 0 4.828Zm0 1.703a4.117 4.117 0 1 0 0-8.234 4.117 4.117 0 0 0 0 8.234Z"
        fill="#51565C"
      />
    </Svg>
  )
)

CareerIcon.propTypes = commonPropTypes
CareerIcon.defaultProps = commonDefaultProps

export default CareerIcon
